export default "__VITE_ASSET__435ea992__"